import * as React from 'react';
import classNames from 'classnames';

import CampaignTimeline from 'modules/campaigns/components/campaign-timeline/components/creatorfull/CampaignTimeline';
import {
  CcmCreatorlessCampaignOverviewTimeline
} from 'modules/campaigns/components/campaign-timeline/components/creatorless';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-timeline.scss';

applyTranslations(require('./ccm-campaign-timeline.i18n.json'));

import type {
  CcmCampaignTimeline as CcmCampaignTimelineType
} from 'types';

type Props = {
  timeline: CcmCampaignTimelineType | null,
  isCampaignCreatorless?: boolean
};

const MSG_KEY = 'ccm_campaign_timeline';

const CcmCampaignTimeline: React.FC<Props> = ({
  timeline,
  isCampaignCreatorless
}): JSX.Element => {
  if (Boolean(isCampaignCreatorless) && timeline !== null) {
    return (
      <CcmCreatorlessCampaignOverviewTimeline
        timeline={timeline}
      />
    );
  }

  const timelineClasses = classNames('ccm-campaign-timeline__component', {
    'ccm-campaign-timeline__component--flex': isCampaignCreatorless
  });

  const classes = classNames('ccm-campaign-timeline', {
    'ccm-campaign-timeline--direction-column': isCampaignCreatorless
  });

  return (
    <div className={classes}>
      <div className="ccm-campaign-overview__title">
        {__t(`${MSG_KEY}.title`)}
      </div>
      <div className={timelineClasses}>
        <CampaignTimeline
          timeline={timeline}
          withSlimLayout
        />
      </div>
    </div>
  );
};

export default CcmCampaignTimeline;
